import { render, staticRenderFns } from "./page2part6.vue?vue&type=template&id=e1126856&scoped=true"
import script from "./page2part6.vue?vue&type=script&lang=js"
export * from "./page2part6.vue?vue&type=script&lang=js"
import style0 from "./page2part6.vue?vue&type=style&index=0&id=e1126856&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1126856",
  null
  
)

export default component.exports